import SPHMediaLogoFooter from "@assets/SPHMediaLogo.svg";
import { FooterAdvertise } from "@footer/FooterAdvertise";
import { FooterCopyright } from "@footer/FooterCopyright";
import { FooterLinks } from "@footer/FooterLinks";
import type { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type FooterProps = {
  testId?: string;
  className?: string;
};

export function Footer({
  testId = "footer",
  className,
}: FooterProps): ReactElement {
  return (
    <>
      <footer
        className={twMerge(
          "w-full bg-red-800 py-11 px-5 xmd:px-12 lg:px-16 xl:px-28",
          className,
        )}
      >
        <div
          data-testid={`${testId}-footerContainer`}
          className="grid lg:flex w-full xl:max-w-[1197px] mx-auto gap-8 md:gap-5"
        >
          <div className="inline-block w-full">
            <div className="flex mb-2.5">
              <Link to="https://www.sph.com.sg/" rel="home" title="Home">
                <img
                  height="47px"
                  width="139px"
                  alt="Home"
                  loading="lazy"
                  src={SPHMediaLogoFooter}
                />
              </Link>
            </div>
            <FooterCopyright testId={testId} />
            <FooterLinks testId={testId} />
          </div>
          <FooterAdvertise testId={testId} />
        </div>
      </footer>
    </>
  );
}
